import { MOK_SURROUND_PREFIX } from '../../surround-material/constants';

import type { Island } from '../../islands/island.class';

/** MOKS islands ship as a single molded shell with no separate trim hardware (GitHub #467). */
export const isMokIsland = (island: Island | null): boolean => {
	return (island?.surround?.key ?? '').startsWith(MOK_SURROUND_PREFIX);
};
